import { render, staticRenderFns } from "./CryptoPortfolio.vue?vue&type=template&id=6d1d387a&"
import script from "./CryptoPortfolio.vue?vue&type=script&lang=js&"
export * from "./CryptoPortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports